// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#venusUI {
  /**
   * Usage:
   *    p { .withBorder() } => p { border: @box-border }
   *    p { .withBorder(@border: @border) } => p { border: @border }
   *    p { .withBorder(true; @border) } => p { border: @border }
   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }
   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }
   */
}
/* css taken from neptune/apps/keycloak/themes/neptune/login/resources/css/login.css */
.keycloak-scene {
  width: 100%;
  height: 100%;
  background-color: var(--color-background-base);
}
.keycloak-scene__main {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: auto;
}
.keycloak-scene__aside {
  width: 33.333333vw;
  overflow-y: auto;
}
@media all and (max-width: 1024px) {
  .keycloak-scene__aside {
    display: none;
  }
}
.keycloak-scene__content {
  box-sizing: border-box;
  display: flex;
  flex: 1;
  flex-direction: column;
  margin: 0;
  padding: 32px 0;
  width: 480px;
}
@media all and (max-width: 540px) {
  .keycloak-scene__content {
    display: block;
    flex: none;
    width: 100%;
    max-width: 498px;
    /* with padding */
    height: auto;
  }
}
.keycloak-scene__logo {
  min-width: 140px;
  margin-top: 50px;
  text-align: center;
}
.keycloak-scene__help {
  padding: 32px 0;
  margin: 0 auto;
  min-width: 360px;
  text-align: center;
}
@media all and (max-width: 540px) {
  .keycloak-scene__help {
    padding: 24px 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/shared/venus/ui/less/mixins/decorators.less","webpack://./src/neptune-app/libs/shared/keycloak/ui/KeycloakScene.less"],"names":[],"mappings":"AAEA;ECDE;;;;;;;IAOE;AACJ;AACA,sFAAsF;AANtF;EACE,WAAA;EACA,YAAA;EACA,8CAAA;AAQF;AANE;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,cAAA;AAQJ;AALE;EACE,kBAAA;EACA,gBAAA;AAOJ;AALI;EAAA;IACE,aAAA;EAQJ;AACF;AALE;EACE,sBAAA;EACA,aAAA;EACA,OAAA;EACA,sBAAA;EACA,SAAA;EACA,eAAA;EACA,YAAA;AAOJ;AALI;EAAA;IACE,cAAA;IACA,UAAA;IACA,WAAA;IACA,gBAAA;IAQF,iBAAiB;IAPf,YAAA;EASJ;AACF;AANE;EACE,gBAAA;EACA,gBAAA;EACA,kBAAA;AAQJ;AALE;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AAOJ;AALI;EAAA;IACE,eAAA;EAQJ;AACF","sourcesContent":["@import \"../variables.less\";\n\n#venusUI {\n\n  /**\n   * Usage:\n   *    p { .withBorder() } => p { border: @box-border }\n   *    p { .withBorder(@border: @border) } => p { border: @border }\n   *    p { .withBorder(true; @border) } => p { border: @border }\n   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }\n   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }\n   */\n  .withBorder(@sides: true; @border: @box-border ) {\n    .setBorder(@side) when (@side) {\n      border: @border;\n    }\n    .setBorder(@side) when (@side = left), (@side = right), (@side = top), (@side = bottom){\n      border-@{side}: @border;\n    }\n    each(@sides, {\n      .setBorder(@value);\n    });\n  }\n\n  .withBorderRadius(@radius: @box-border-radius) {\n    border-radius: @radius;\n  }\n\n  .withShadow(@shadow: @box-shadow) {\n    box-shadow: @shadow;\n  }\n}\n","@import '~venus';\n\n/* css taken from neptune/apps/keycloak/themes/neptune/login/resources/css/login.css */\n\n.keycloak-scene {\n  width: 100%;\n  height: 100%;\n  background-color: var(--color-background-base);\n\n  &__main {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    overflow: auto;\n  }\n\n  &__aside {\n    width: 33.333333vw;\n    overflow-y: auto;\n\n    @media all and (max-width: @tablet-break) {\n      display: none;\n    }\n  }\n\n  &__content {\n    box-sizing: border-box;\n    display: flex;\n    flex: 1;\n    flex-direction: column;\n    margin: 0;\n    padding: @layoutUnit-xl 0;\n    width: 480px;\n\n    @media all and (max-width: @mobile-break) {\n      display: block;\n      flex: none;\n      width: 100%;\n      max-width: 498px; /* with padding */\n      height: auto;\n    }\n  }\n\n  &__logo {\n    min-width: 140px;\n    margin-top: 50px;\n    text-align: center;\n  }\n\n  &__help {\n    padding: @layoutUnit-xl 0;\n    margin: 0 auto;\n    min-width: 360px;\n    text-align: center;\n\n    @media all and (max-width: @mobile-break) {\n      padding: @layoutUnit-lg 0;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
